import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectJob } from '../redux/actions/selectedJob';
import CompanyLogo from './CompanyLogo';

class HistCat extends Component {
    /*
    StatisticsApi.getCATData({},(response)=>{
        setCATObj(response)

        const words = (response.content||'').trim().split(/\s+/)
        if (words.length <= 20) {
            setIsExpanded(true)
            setDisplayText(response.content)
        } else {
            setDisplayText(words.slice(0, 17).join(' ') + '...')
        }
    }, (error) => {
        //setError(error || 'Something went wrong')
    })
    */
    handleSelect = () => {
        const { dispatch } = this.props
        dispatch(selectJob({
            _id:'cat',
            company:'JobHunt',
            title: 'איך להגיע להזדמנויות הנכונות לפני כולם',
            description: `ג'ובהאנט מלווה מועמדים בהייטק מאז 2008!

                אנחנו יודעים איך לגרום ליכולות שלכם לבלוט על פני המועמדים האחרים
                ואיך לחשוף את הקורות חיים שלכם לעיניים הנכונות בתעשייה.
                
                1. מכירים אותך אישית - מגדירים ביחד את מטרות החיפוש ומזקקים את הטאלנט שלך ביחס לשוק הביקושים.
                
                2. משכתבים את קורות החיים והמכתב המקדים, כך שיכילו את כל מילות המפתח ויעברו את הסנן האוטומטי והאנושי - בדרך לראיון העבודה. 
                
                3. אחת לשבועיים אנחנו מייצרים חשיפה מאסיבית וגישה למשרות בשלב הגיוס הפנימי, לפני שהן מתפרסמות "החוצה".
                
                4. וכל זה עם מענה אישי-מקצועי לאורך כל הדרך, תוך פתרון מותאם לאתגרים שבדרך.`
        }, true));
    };

    render() {
        const { selected, showCat } = this.props;
        
        return (
            <React.Fragment>
                {showCat&&<li className={selected ? 'cat cl selected':'cat cl'} onClick={this.handleSelect}>
                    <div>
                        <CompanyLogo companyName={'JobHunt'} companyUrl={'jobhunt.co.il'} className="clLogo"/>
                    </div>
                    <div className="clInfo">
                        <div dir='auto' className="clTitle" style={{fontWeight: 'bold'}}>{'הידעת? 65% מהמשרות בכלל לא מתפרסמות החוצה!'}</div>
                        <div className="clCompany">JobHunt</div>
                        <div className="clLocation">Israel</div>
                    </div>
                </li>}
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    const {job} = state.selectedJob;
    const histogramType = state.histogramData.histogramType

    return {
        showCat: (histogramType === 'jobs'),
        selected: (job._id === 'cat')
    }
}

export default connect(mapStateToProps)(HistCat)